import AbstractIceContentController from '../../abstract/ice-content/controller';
import WidgetFundComparisonHelpers from './app-fund-comparison';
class Controller extends AbstractIceContentController {
    constructor(widget) {
        super(widget);
        this.init(widget);
    }

    init(widget) {
        let helpers = new WidgetFundComparisonHelpers();
        //Configurable text
        const chooseCurrencyText = decodeURI(widget.getPreference('chooseCurrencyText'));
        const chooseFundsText = decodeURI(widget.getPreference('chooseFundsText'));
        const cantCompareText = decodeURI(widget.getPreference('cantCompareText'));
        const ddDefaultText = decodeURI(widget.getPreference('ddDefaultText'));



        const compareEndpoint = decodeURI(widget.getPreference('compareEndPoint'));
        const compareContentEndpoint = decodeURI(widget.getPreference('compareContentEndpoint'));
        const compareProcessorEndpoint = decodeURI(widget.getPreference('compareProcessorEndpoint'));
        const compareProcessorHeaders = decodeURI(widget.getPreference('compareProcessorHeaders'));
        
        const fundClassText = decodeURI(widget.getPreference('fundClassText'));
        
        
        const startSessionEndpoint ="services/rest/routeProcessor";
        const startSessionHeaders={
            intSvcName:"sis/amtc",
            service:"startSessionAPI"
        };
        //Start Angular JS
        let moduleFundComparison = angular.module("moduleFundComparison", []);
        let initialFund = helpers.getFundIdParameters(window.location.search, "fundId");

        let fundComparisonController = function ($scope) {
            //Apply Configurations
            $scope.chooseCurrencyText = chooseCurrencyText;
            $scope.chooseFundsText = chooseFundsText;
            $scope.cantCompareText=cantCompareText;
            $scope.ddDefaultText=ddDefaultText;

            //Start Session
            helpers.startSession(startSessionEndpoint,startSessionHeaders).then((result) => {
                sessionStorage.setItem("s_key",result.transactionId);
            }).catch((err) => {
                console.log("Error fetching the funds, no connection");
            });



            //Toggle Show more and show less
            $scope.showThis=[false,false,false];
            $scope.toggleDetails=function(i){
                if($scope.showThis[i]){
                    $scope.showThis[i]=false;
                }else{
                    $scope.showThis[i]=true;
                }
            }

            //fetch all the funds from the portal content
            $scope.allFunds = [];
            let urlContent = "/services/rest/amtc/content";
            let amtcContentProductsPath = compareContentEndpoint;
            let amtcContentProcessorPath =compareProcessorEndpoint;
            let amtcContentProcessorHeaders =compareProcessorHeaders;
           
            $scope.defaultLoader=true;  //display Loader on Initialize
            // helpers.getAmtcProducts(urlContent, amtcContentProductsPath).then((result) => {
            //     $scope.allFunds =result.productList;
            //     $scope.$apply(() => {
            //         $scope.defaultLoader = false;
            //         $scope.loadInitialFund();
            //     });compareContentEndpoint
            // }).catch((err) => {
            //     console.log("Error fetching the funds, no connection");
            // });

            //V2
            helpers.getAmtcProductsV2(amtcContentProductsPath,amtcContentProcessorPath,amtcContentProcessorHeaders).then((result) => {
                $scope.allFunds =result.productList;
                $scope.$apply(() => {
                    $scope.defaultLoader = false;
                    $scope.loadInitialFund();
                });
            }).catch((err) => {
                console.log("Error fetching the funds, no connection");
            });

            //Load the fund from query params
            $scope.loadInitialFund=function(){
                if(initialFund){
                    let initFund="";
                    $scope.allFunds.map((a) => {
                        if(a.fundID === initialFund){
                            initFund=a;
                        }
                    });
                    $scope.checkPreselected(initFund.baseCurrency);
                    $scope.setSelected(initFund);
                }
            }


            $scope.selectedFundComps = [];

            //Check for Preselection
            $scope.currency = "";
            $scope.temp="";
            $scope.checkPreselected=function(currency){
                $scope.temp=currency;
                //if($scope.currency==""){
                    $scope.currency=currency;
                    $scope.filterCurrency();
                // }else{
                //     $scope.showDialog=true;
                // }
            }

            $scope.closeDialog=function(ans){
                if(ans){
                    $scope.currency =$scope.temp;
                    $scope.filterCurrency();
                }
                //$scope.showDialog=false;
            }


            //filtering by Currency
            $scope.filteredByCurrency=[];
            $scope.filterCurrency=function(){
                $scope.filteredByCurrency=[];
                $scope.allFunds.map((a) => {
                    if($scope.currency === a.baseCurrency){
                        $scope.filteredByCurrency.push(a);
                    }
                });
                //console.log("Filtered by Currency",$scope.filteredByCurrency);

                if($scope.selectedFundComps.length>0){
                    $scope.selectedFundComps=[];
                }
                $scope.filterByAssetClass();
            };

            //filtering by assetClass
           
            $scope.assetClasses = JSON.parse(fundClassText); //asset class from widget properties
         
            $scope.moneyMarketFunds=[];
            $scope.equityFunds=[];
            $scope.bondFunds=[];
            $scope.balancedfunds=[];

            $scope.filterByAssetClass=function(){
                //Clear First
                $scope.assetClasses.map((a) => {
                    a.funds=[];
                });
                $scope.filteredByCurrency.map((a) => {
                    // console.log($scope.assetClasses[0].fundClassID);
                    if(a.assetClass===$scope.assetClasses[0].fundClassID){
                        $scope.assetClasses[0].funds.push(a);
                    }
                    if(a.assetClass===$scope.assetClasses[1].fundClassID){
                        $scope.assetClasses[1].funds.push(a);
                    }
                    if(a.assetClass===$scope.assetClasses[2].fundClassID){
                        $scope.assetClasses[2].funds.push(a);
                    }
                    if(a.assetClass===$scope.assetClasses[3].fundClassID){
                        $scope.assetClasses[3].funds.push(a);
                    }

                });

                //console.log($scope.assetClasses);
            }

            //Selected Funds
            $scope.setSelected = function (fund) {
                helpers.apiRequestCanceller();
                $scope.displayShowGraphBtn=true;
                $scope.showTable = false;
                $scope.selectedFundComps.push(fund);
                $scope.filterSelected(fund.assetClass,fund.fundID);
            }

            //Filter array for second and third fund selection
            //Remove the fund once it is selected
            $scope.secondDropDownFunds=[];
            $scope.filterForSecondDropdown=function(filteredAssetClass){
                let filteredFunds=filteredAssetClass[0].funds.filter(function(e) { 
                    return e.fundID !== $scope.selectedFundComps[0].fundID;
                });
                $scope.secondDropDownFunds=filteredAssetClass;
                $scope.secondDropDownFunds[0].funds=filteredFunds;
            }

            $scope.thirdDropDownFunds=[];
            $scope.filterForThirdDropdown=function(filteredAssetClass){
                let filteredFunds=filteredAssetClass[0].funds.filter(function(e) { 
                    return e.fundID !== $scope.selectedFundComps[0].fundID && e.fundID!=$scope.selectedFundComps[1].fundID;
                });
                $scope.thirdDropDownFunds=filteredAssetClass;
                $scope.thirdDropDownFunds[0].funds=filteredFunds;
            }

            $scope.filterSelected=function(fundClass,fundID){   
                //Filter By Fund Class
                $scope.filterByAssetClass();
                let filteredAssetClass=$scope.assetClasses.filter(function(e){
                    return e.fundClassID === fundClass;
                });
                if($scope.selectedFundComps.length==1){
                $scope.filterForSecondDropdown(filteredAssetClass);
                }else{
                $scope.filterForSecondDropdown(filteredAssetClass);
                $scope.filterForThirdDropdown(filteredAssetClass);
                }   
            }

            $scope.resetSelection=function(id){
                $scope.filterSelected($scope.selectedFundComps[id].assetClass,$scope.selectedFundComps[id].fundID)
            }

            $scope.closeIndex1 =false;
            $scope.closeIndex2 =false;
            $scope.enableTransition=true;
            $scope.removeFund = function (fund) {
                helpers.apiRequestCanceller();
                $scope.displayShowGraphBtn=true;
                $scope.showTable = false;
                $scope.enableTransition=true;
                $scope.selectedFundComps.splice(fund,1);
                if(fund=="all"){
                    $scope.selectedFundComps=[];
                    $scope.filterCurrency();
                }else{
                    if($scope.selectedFundComps.length>0){
                        if(fund==0){
                            $scope.resetSelection(fund);
                            
                        }else{
                            $scope.resetSelection(fund-1);
                        }
                    }else{
                        $scope.filterByAssetClass();
                    }
                    
                    if(fund==1){
                        $scope.showSecondDropdown=false;
                    }
                    if(fund==2){
                        $scope.showThirdDropdown=false;
                    }
                }
                
                // setTimeout(()=>{
                //     $scope.$apply(() => {
                //         if(fund==0){
                //             $scope.closeIndex1=true;
                //             $scope.closeIndex2=true;
                //         }
                //         if(fund==1){
                //             $scope.closeIndex1 =false;
                //             $scope.closeIndex2=true;
                //         }
                //     });
                // },300);
                
                // $scope.funds = $scope.funds.filter(function (arr) {
                //     if (arr.fundID == fund) {
                //         arr.selected = false;
                //     }
                //     return arr;
                // });
                // var selectedFunds = $scope.funds.filter(function (arr) {
                //     return arr.selected == true;
                // });

                // setTimeout(()=>{
                //     $scope.$apply(() => {
                //         $scope.selectedFundComps.splice(fund,1);
                //         $scope.enableTransition=false;
                //         $scope.closeIndex1 =false;
                //         $scope.closeIndex2 =false;
                //     });
                // },700);
               
               
            }

            $scope.showSecondDropdown=false;
            $scope.showThirdDropdown=false;

            $scope.showFundClass = false;
            $scope.toggleDisplaySecondSelect = function (val) {
                $scope.showSecondDropdown=true;

                if (val) {
                    $scope.showFundClass = false; //hide onBlur
                    $scope.showSecondDropdown=false;
                } else {
                    $scope.showFundClass = !$scope.showFundClass;
                    $scope.showSecondDropdown=true;
                }

            }

            $scope.showFunds = false;
            $scope.toggleDisplayThirdSelect= function (val) {
                $scope.showThirdDropdown=true;

                if (val) {
                    $scope.showFunds = false; //hide onBlur
                    $scope.showThirdDropdown=false;
                } else {
                    $scope.showFunds = !$scope.showFunds;
                    $scope.showThirdDropdown=true;
                }

            }
            
            /* #region  Dropdown Toggle */
            $scope.showRiskList = false;
            $scope.toggleDisplayFirstFund = function (val) {
                if (val) {
                    $scope.showRiskList = false; //hide onBlur
                } else {
                    $scope.showRiskList = !$scope.showRiskList;
                }
            }
            /* #endregion */


            $scope.showTable = false;

            $scope.ytd = true;
            $scope.oneYear = false;
            $scope.threeYears = false;
            $scope.fiveYears = false;
            $scope.ytdDef = false;
            $scope.oneYearDef = true;
            $scope.threeYearsDef = true;
            $scope.fiveYearsDef = true;
            $scope.displayLoader = false;

            $scope.showDialogCompare0 = false;
            $scope.showDialogCompare1 = false;
            $scope.showDialogCompare2 = false;
            $scope.fundNameComp0 = "fund";
            $scope.fundHorizonComp0 = "horizon";
            $scope.fundInceptionDateComp0 = "inception Date";
            $scope.fundNameComp1 = "fund";
            $scope.fundHorizonComp1 = "horizon";
            $scope.fundInceptionDateComp1 = "inception Date";
            $scope.fundNameComp2 = "fund";
            $scope.fundHorizonComp2 = "horizon";
            $scope.fundInceptionDateComp2 = "inception Date";
            $scope.closeDialogCompare = function (i) {
                if (i == 0) {
                    $scope.showDialogCompare0 = false;
                }
                if (i == 1) {
                    $scope.showDialogCompare1 = false;
                }
                if (i == 2) {
                    $scope.showDialogCompare2 = false;
                }
            }


            $scope.displayShowGraphBtn=true;

            $scope.hideChart = false;
            $scope.hideChartClick=function(){
                $scope.displayShowGraphBtn=true;
                $scope.showTable = false;
            }

            $scope.blockCall = false;
            $scope.compareFunds = function (term) {
                //ToDo: Dialog box for fund with incomplete data
                if (!$scope.blockCall) {
                    $scope.displayShowGraphBtn=false;
                    $scope.showTable = true; //Display Selected Fund Table
                    var horizon = term;
                    let fundIDSelected = Object.values($scope.selectedFundComps).map((e) => {
                        return e.fundID;
                    })

                    let urlMarketValue = compareEndpoint;
                    $scope.displayLoader = true;

                    $scope.blockCall = true;
                    helpers.getMarketValue(fundIDSelected, horizon, urlMarketValue).then((result) => {
                        let fundResult = result;
                        let fundObject = [];
                        for (let x = 0; x < fundResult.funds.length; x++) {
                            var values = Object.values(fundResult.funds[x].navpuList).map(function (key) {
                                var dformat = new Date(key.dateValue);
                                var month = dformat.getMonth() + 1;
                                var day = dformat.getDate();
                                var year = dformat.getFullYear();
                                var format = month + "/" + day + "/" + year;
                                return { t: format, y: parseInt(key.marketValue) };
                            });

                            if (!fundResult.funds[x].isInvestmentTermValid && horizon <= 5 && horizon != 0) {
                                if (x == 0) {
                                    $scope.showDialogCompare0 = true;
                                    $scope.fundNameComp0 = fundResult.funds[x].fundName;
                                    $scope.fundHorizonComp0 = horizon;
                                    $scope.fundInceptionDateComp0 = fundResult.funds[x].inceptionDate;
                                }
                                if (x == 1) {
                                    $scope.showDialogCompare1 = true;
                                    $scope.fundNameComp1 = fundResult.funds[x].fundName;
                                    $scope.fundHorizonComp1 = horizon;
                                    $scope.fundInceptionDateComp1 = fundResult.funds[x].inceptionDate;
                                }
                                if (x == 2) {
                                    $scope.showDialogCompare2 = true;
                                    $scope.fundNameComp2 = fundResult.funds[x].fundName;
                                    $scope.fundHorizonComp2 = horizon;
                                    $scope.fundInceptionDateComp2 = fundResult.funds[x].inceptionDate;
                                }

                                $scope.hideChart = false;
                                fundObject.push({
                                    fundName: fundResult.funds[x].fundName,
                                    fundCurr: $scope.selectedFundComps[x].baseCurrency,
                                    fundData: values
                                });
                                helpers.loadChart(fundObject);
                            } else {
                                fundObject.push({
                                    fundName: fundResult.funds[x].fundName,
                                    fundCurr: $scope.selectedFundComps[x].baseCurrency,
                                    fundData: values
                                });
                            }
                        }
                        $scope.$apply(() => {
                            $scope.displayLoader = false;
                            $scope.blockCall = false;
                        });
                        helpers.loadChart(fundObject);
                        helpers.startSession(startSessionEndpoint,startSessionHeaders).then((result) => {
                            sessionStorage.setItem("s_key",result.transactionId);
                        }).catch((err) => {
                            console.log("Error starting session, no connection");
                        });
                    }).catch((err) => {
                        helpers.startSession(startSessionEndpoint,startSessionHeaders).then((result) => {
                            sessionStorage.setItem("s_key",result.transactionId);
                        }).catch((err) => {
                            console.log("Error starting session, no connection");
                        });
                        $scope.$apply(() => {
                            $scope.displayLoader = false;
                            $scope.blockCall = false;
                        });

                        //FOR DEBUGGING Purposes only, will remove
                        // var mockChartData = [
                        //     { fundName: "testfundA", fundCurr: "Peso", fundData: [{ t: "06/25/2018", y: 10000 }, { t: "08/25/2018", y: 10000 }, { t: "09/25/2018", y: 10000 }] },
                        //     { fundName: "testfundB", fundCurr: "Peso", fundData: [{ t: "06/25/2018", y: 8000 }, { t: "09/25/2018", y: 9000 }, { t: "10/25/2018", y: 8000 }] },
                        //     { fundName: "testfundC", fundCurr: "Peso", fundData: [{ t: "06/25/2018", y: 7000 }, { t: "07/25/2018", y: 8000 }, { t: "10/20/2018", y: 5000 }] }
                        // ];
                        // helpers.loadChart(mockChartData);

                    });
                    if (term == 0) {
                        $scope.ytd = true;
                        $scope.oneYear = false;
                        $scope.threeYears = false;
                        $scope.fiveYears = false;
                        $scope.ytdDef = false;
                        $scope.oneYearDef = true;
                        $scope.threeYearsDef = true;
                        $scope.fiveYearsDef = true;
                    } else if (term == 1) {
                        $scope.ytd = false;
                        $scope.oneYear = true;
                        $scope.threeYears = false;
                        $scope.fiveYears = false;
                        $scope.ytdDef = true;
                        $scope.oneYearDef = false;
                        $scope.threeYearsDef = true;
                        $scope.fiveYearsDef = true;
                    } else if (term == 3) {
                        $scope.ytd = false;
                        $scope.oneYear = false;
                        $scope.threeYears = true;
                        $scope.fiveYears = false;
                        $scope.ytdDef = true;
                        $scope.oneYearDef = true;
                        $scope.threeYearsDef = false;
                        $scope.fiveYearsDef = true;
                    } else if (term == 5) {
                        $scope.ytd = false;
                        $scope.oneYear = false;
                        $scope.threeYears = false;
                        $scope.fiveYears = true;
                        $scope.ytdDef = true;
                        $scope.oneYearDef = true;
                        $scope.threeYearsDef = true;
                        $scope.fiveYearsDef = false;
                    }
                }
            }
        }

        let toTitleCaseFilter = function () {
            return function (value) {
                if (value) {
                    return helpers.toTitleCase(value);
                } else {
                    return "";
                }
            }
        }
        let pluralizedYear = function () {
            return function (value) {
                if (value > 1) {
                    return value + " yrs";
                } else {
                    return value + " yr";
                }
            }
        }
        let removePortalserver = function () {
            return function (value) {
                return `/${App.Utils.Helpers.getRelativePath()}${value}`;
            }
        }
        /* #region  AngularJs Loader */
        moduleFundComparison.controller('FundComparisonController', [ '$scope', fundComparisonController ]);
        moduleFundComparison.filter('toTitleCase', toTitleCaseFilter);
        moduleFundComparison.filter('pluralizedYear', pluralizedYear);
        moduleFundComparison.filter('removePortalserver', removePortalserver);
        moduleFundComparison.directive("ngFundComparisonPartial", function () {
            return {
                template: require('../templates/fund-comparison-partial.html')
            };
        });
        angular.element(document.getElementById('fundComparison')).ready(function () {
            var fundComparisonTemplate = document.createElement('ng-fund-comparison-partial');
            document.getElementById("desclaimer").setAttribute("ng-show", "showTable");
            if (document.getElementById('partial-fund-comparison')) {
                document.getElementById('partial-fund-comparison').appendChild(fundComparisonTemplate);
            }

            angular.bootstrap(document.getElementById("amtcFundComparison"), ['moduleFundComparison']);
        });
        /* #endregion */
    }
}

export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-amtc-fund-comparison/scripts/controller.js